/* Pasanka smooth scrolling (Lenis).
   Only the scroll feel changes: the mouse wheel / trackpad glides instead of stepping.
   Touch screens keep their native momentum scrolling. It stays off for reduced-motion
   and the theme editor, and the site scrolls normally if the library cannot load. */
(function () {
  'use strict';

  var doc = document, root = doc.documentElement;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  // motion.js (when the layout loads it) already runs its own Lenis smooth scroll: never start a second one.
  if (doc.querySelector('script[src*="motion.js"]')) return;

  var LENIS = 'https://cdn.jsdelivr.net/npm/lenis@1.1.18/dist/lenis.min.js';

  // Lenis needs the native CSS smooth-scroll off while it runs.
  var style = doc.createElement('style');
  style.textContent =
    'html.lenis,html.lenis body{height:auto}' +
    '.lenis.lenis-smooth{scroll-behavior:auto!important}' +
    '.lenis.lenis-stopped{overflow:hidden}' +
    '.lenis.lenis-smooth [data-lenis-prevent]{overscroll-behavior:contain}';
  doc.head.appendChild(style);

  var s = doc.createElement('script');
  s.src = LENIS;
  s.async = true;
  s.onerror = function () { style.remove(); };
  s.onload = function () {
    if (!window.Lenis) return;

    var lenis = new window.Lenis({
      lerp: 0.1,
      smoothWheel: true,
      // Scrollable panels (cart drawer, popups, dropdown lists, menus, text areas) keep native scrolling.
      prevent: function (node) {
        return !!(node.closest && node.closest('[data-cart-drawer], .pas-modal, .pas-select-list, [data-search-results], [data-mobile-menu], textarea, select'));
      }
    });

    var raf = function (time) { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);

    // The cart drawer and menus lock page scroll by setting overflow on <html>.
    var sync = function () { if (root.style.overflow === 'hidden') lenis.stop(); else lenis.start(); };
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['style'] });
    sync();

    // In-page links (#top, #orders, #wholesale-inquiry ...) glide too, clear of the floating header.
    doc.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || e.defaultPrevented) return;
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target = null;
      try { target = doc.querySelector(id); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -96 });
    });

    window.pasankaLenis = lenis;
  };
  doc.head.appendChild(s);
})();
